import { Component } from "@builder.io/sdk";

export const careersAboutUsConfig: Component = {
  name: "Careers About Us",
  inputs: [
    {
      name: "id",
      type: "string",
      defaultValue: "careers-about-us",
      helperText:
        "Unique identifier for the section. Useful for linking to the section by '#id'.",
      advanced: true,
    },
    {
      name: "className",
      type: "string",
      helperText: "Additional CSS classes for the section",
      advanced: true,
    },
    {
      name: "title",
      type: "string",
      required: true,
      defaultValue: "Care Indeed: A Legacy of Compassionate Care",
      helperText: "Main title for the section",
    },
    {
      name: "subtitle",
      type: "string",
      required: true,
      defaultValue: "Committed to Excellence in Senior Home Care",
      helperText: "Subtitle that appears below the main title",
    },
    {
      name: "description",
      type: "richText",
      defaultValue:
        "Founded in 2010 by two experienced nurses, Care Indeed has grown into a leading provider of in-home care services in the Bay Area. With a team of over 700 dedicated professionals across four offices, we are consistently recognized as one of the Top 50 Best Companies to Work For. Our core values—excellence, respect, and authenticity—guide our mission to deliver unparalleled care to our clients and a supportive environment for our employees.",
      helperText: "Descriptive text that appears below the subtitle",
    },
    {
      name: "images",
      type: "object",
      defaultValue: {
        topLeftImages: [
          {
            url: "https://cdn.builder.io/api/v1/image/assets%2Fad5264505ff74b8ba929a635f7c3c34f%2Fd402e858a98446f896176380cb621fc0",
            alt: "Care Indeed team member - top left",
          },
          {
            url: "https://cdn.builder.io/api/v1/image/assets%2Fad5264505ff74b8ba929a635f7c3c34f%2F3b4a499cbca54965bf7393e9dd5d1b1d",
            alt: "Care Indeed team member - top left alternate",
          },
          {
            url: "https://cdn.builder.io/api/v1/image/assets%2Fad5264505ff74b8ba929a635f7c3c34f%2F5e3a5d55927a4ed4b496e6bfecc25f63",
            alt: "Care Indeed team member - top left alternate 2",
          },
          {
            url: "https://cdn.builder.io/api/v1/image/assets%2Fad5264505ff74b8ba929a635f7c3c34f%2F2712358d264b4ee3a539dbb1a31b798a",
            alt: "Care Indeed team member - top left alternate 3",
          },
          {
            url: "https://cdn.builder.io/api/v1/image/assets%2Fad5264505ff74b8ba929a635f7c3c34f%2F76eef15a17d84cb79e20f941703619ed",
            alt: "Care Indeed team member - top left alternate 4",
          },
        ],
        topRightImages: [
          {
            url: "https://cdn.builder.io/api/v1/image/assets%2Fad5264505ff74b8ba929a635f7c3c34f%2F9d6da23da3f8481894837e96c54de45d",
            alt: "Care Indeed team celebration - top right",
          },
          {
            url: "https://cdn.builder.io/api/v1/image/assets%2Fad5264505ff74b8ba929a635f7c3c34f%2Fb992a5ddbfe24545a97eaff75244d2bb",
            alt: "Care Indeed team celebration - top right alternate",
          },
          {
            url: "https://cdn.builder.io/api/v1/image/assets%2Fad5264505ff74b8ba929a635f7c3c34f%2F769388f7697844e7bf92cd43b2b6e630",
            alt: "Care Indeed team celebration - top right alternate 2",
          },
          {
            url: "https://cdn.builder.io/api/v1/image/assets%2Fad5264505ff74b8ba929a635f7c3c34f%2F8dd2312cd8404fb2acd46929aca1f0ed",
            alt: "Care Indeed team celebration - top right alternate 3",
          },
          {
            url: "https://cdn.builder.io/api/v1/image/assets%2Fad5264505ff74b8ba929a635f7c3c34f%2Fa072cabdaf124e4eb77d6f54537c6ca7",
            alt: "Care Indeed team celebration - top right alternate 4",
          },
        ],
        bottomLeftImages: [
          {
            url: "https://cdn.builder.io/api/v1/image/assets%2Fad5264505ff74b8ba929a635f7c3c34f%2F5c67d996f8ff40839956dfdbb1e8ec56",
            alt: "Care Indeed team meeting - bottom left",
          },
          {
            url: "https://cdn.builder.io/api/v1/image/assets%2Fad5264505ff74b8ba929a635f7c3c34f%2F32edfe91fe964d0a93b6e768ae7e4f24",
            alt: "Care Indeed team meeting - bottom left alternate",
          },
          {
            url: "https://cdn.builder.io/api/v1/image/assets%2Fad5264505ff74b8ba929a635f7c3c34f%2F6a425c09deb84f1dbf5c727dbc4def4d",
            alt: "Care Indeed team meeting - bottom left alternate 2",
          },
          {
            url: "https://cdn.builder.io/api/v1/image/assets%2Fad5264505ff74b8ba929a635f7c3c34f%2F5f8c53f026fc48a7bbb624ecb8db119d",
            alt: "Care Indeed team meeting - bottom left alternate 3",
          },
          {
            url: "https://cdn.builder.io/api/v1/image/assets%2Fad5264505ff74b8ba929a635f7c3c34f%2Fa83ab90dc22d4feaa1c9ddbf5e2bfe75",
            alt: "Care Indeed team meeting - bottom left alternate 4",
          },
        ],
        bottomRightImages: [
          {
            url: "https://cdn.builder.io/api/v1/image/assets%2Fad5264505ff74b8ba929a635f7c3c34f%2F628704252c324aebb447df1ad223f6e5",
            alt: "Care Indeed caregivers - bottom right",
          },
          {
            url: "https://cdn.builder.io/api/v1/image/assets%2Fad5264505ff74b8ba929a635f7c3c34f%2F6ece3106bec848ec9a329d5c9b5d839a",
            alt: "Care Indeed caregivers - bottom right alternate",
          },
          {
            url: "https://cdn.builder.io/api/v1/image/assets%2Fad5264505ff74b8ba929a635f7c3c34f%2Fc79a425a3f2c48069a78171d054d29c3",
            alt: "Care Indeed caregivers - bottom right alternate 2",
          },
          {
            url: "https://cdn.builder.io/api/v1/image/assets%2Fad5264505ff74b8ba929a635f7c3c34f%2F58a863d8278c40988aa1ca9f21e5fa07",
            alt: "Care Indeed caregivers - bottom right alternate 3",
          },
          {
            url: "https://cdn.builder.io/api/v1/image/assets%2Fad5264505ff74b8ba929a635f7c3c34f%2F78a9a753589c43b1bbd79aaff9a42267",
            alt: "Care Indeed caregivers - bottom right alternate 4",
          },
        ],
        mobileFullHeightImages: [
          {
            url: "https://cdn.builder.io/api/v1/image/assets%2Fad5264505ff74b8ba929a635f7c3c34f%2Feb52abac2af24184abebbf56e855ac3e",
            alt: "Care Indeed mobile full height image",
          },
          {
            url: "https://cdn.builder.io/api/v1/image/assets%2Fad5264505ff74b8ba929a635f7c3c34f%2Feb5ed1aea43c4ed2abafc0f2b1cc677b",
            alt: "Care Indeed mobile full height image alternate",
          },
          {
            url: "https://cdn.builder.io/api/v1/image/assets%2Fad5264505ff74b8ba929a635f7c3c34f%2F79cf95d8357a42979f4425ba51848c4a",
            alt: "Care Indeed mobile full height image alternate 2",
          },
          {
            url: "https://cdn.builder.io/api/v1/image/assets%2Fad5264505ff74b8ba929a635f7c3c34f%2Fa761867ae8054613b7f49d03058ce243",
            alt: "Care Indeed mobile full height image alternate 3",
          },
          {
            url: "https://cdn.builder.io/api/v1/image/assets%2Fad5264505ff74b8ba929a635f7c3c34f%2Fe8f0f0286a0e4fa0bedb918e1292a431",
            alt: "Care Indeed mobile full height image alternate 4",
          },
        ],
      },
      subFields: [
        {
          name: "topLeftImages",
          type: "list",
          subFields: [
            {
              name: "url",
              type: "file",
              required: true,
              allowedFileTypes: ["jpeg", "png", "webp"],
              friendlyName: "Image URL",
              helperText: "URL for the image",
            },
            {
              name: "alt",
              type: "string",
              friendlyName: "Alt Text",
              helperText: "Alt text for the image",
            },
          ],
          helperText:
            "Top left images (1st column, 1st row). Desktop: aspect-[196/172], Tablet: aspect-[340/172]. Also used in mobile layout (2nd column, 1st row).",
        },
        {
          name: "topRightImages",
          type: "list",
          subFields: [
            {
              name: "url",
              type: "file",
              required: true,
              allowedFileTypes: ["jpeg", "png", "webp"],
              friendlyName: "Image URL",
              helperText: "URL for the image",
            },
            {
              name: "alt",
              type: "string",
              friendlyName: "Alt Text",
              helperText: "Alt text for the image",
            },
          ],
          helperText:
            "Top right images (2nd column, 1st row). Desktop: aspect-[302/172], Tablet: aspect-[340/172]. Hidden on mobile.",
        },
        {
          name: "bottomLeftImages",
          type: "list",
          subFields: [
            {
              name: "url",
              type: "file",
              required: true,
              allowedFileTypes: ["jpeg", "png", "webp"],
              friendlyName: "Image URL",
              helperText: "URL for the image",
            },
            {
              name: "alt",
              type: "string",
              friendlyName: "Alt Text",
              helperText: "Alt text for the image",
            },
          ],
          helperText:
            "Bottom left images (1st column, 2nd row). Desktop: aspect-[302/172], Tablet: aspect-[340/172]. Hidden on mobile.",
        },
        {
          name: "bottomRightImages",
          type: "list",
          subFields: [
            {
              name: "url",
              type: "file",
              required: true,
              allowedFileTypes: ["jpeg", "png", "webp"],
              friendlyName: "Image URL",
              helperText: "URL for the image",
            },
            {
              name: "alt",
              type: "string",
              friendlyName: "Alt Text",
              helperText: "Alt text for the image",
            },
          ],
          helperText:
            "Bottom right images (2nd column, 2nd row). Desktop: aspect-[196/172], Tablet: aspect-[340/172]. Also used in mobile layout (2nd column, 2nd row).",
        },
        {
          name: "mobileFullHeightImages",
          type: "list",
          subFields: [
            {
              name: "url",
              type: "file",
              required: true,
              allowedFileTypes: ["jpeg", "png", "webp"],
              friendlyName: "Image URL",
              helperText: "URL for the image",
            },
            {
              name: "alt",
              type: "string",
              friendlyName: "Alt Text",
              helperText: "Alt text for the image",
            },
          ],
          helperText:
            "Mobile-only full height images (1st column spanning both rows). aspect-[175/264]. Not displayed on tablet or desktop.",
        },
      ],
      helperText:
        "Single image set for all device sizes with responsive layouts. Each position can contain multiple images for transition effects.",
    },
    {
      name: "transitions",
      type: "object",
      advanced: false,
      defaultValue: {
        topLeftDelay: 1500,
        topRightDelay: 1200,
        bottomLeftDelay: 1300,
        bottomRightDelay: 1200,
        mobileFullHeightDelay: 1500,

        topLeftDuration: 800,
        topRightDuration: 800,
        bottomLeftDuration: 800,
        bottomRightDuration: 800,
        mobileFullHeightDuration: 800,

        duration: 800,
      },
      subFields: [
        {
          name: "topLeftDelay",
          type: "number",
          helperText:
            "Delay in milliseconds before starting the transition for top left images",
        },
        {
          name: "topRightDelay",
          type: "number",
          helperText:
            "Delay in milliseconds before starting the transition for top right images",
        },
        {
          name: "bottomLeftDelay",
          type: "number",
          helperText:
            "Delay in milliseconds before starting the transition for bottom left images",
        },
        {
          name: "bottomRightDelay",
          type: "number",
          helperText:
            "Delay in milliseconds before starting the transition for bottom right images",
        },
        {
          name: "mobileFullHeightDelay",
          type: "number",
          helperText:
            "Delay in milliseconds before starting the transition for mobile full height images",
        },
        {
          name: "topLeftDuration",
          type: "number",
          helperText:
            "Duration in milliseconds for the transition effect for top left images",
        },
        {
          name: "topRightDuration",
          type: "number",
          helperText:
            "Duration in milliseconds for the transition effect for top right images",
        },
        {
          name: "bottomLeftDuration",
          type: "number",
          helperText:
            "Duration in milliseconds for the transition effect for bottom left images",
        },
        {
          name: "bottomRightDuration",
          type: "number",
          helperText:
            "Duration in milliseconds for the transition effect for bottom right images",
        },
        {
          name: "mobileFullHeightDuration",
          type: "number",
          helperText:
            "Duration in milliseconds for the transition effect for mobile full height images",
        },
        {
          name: "duration",
          type: "number",
          helperText:
            "Default duration in milliseconds for the transition effect - used if individual durations are not specified",
        },
      ],
      helperText:
        "Configure the timing for image transitions. Delay is the time before transitions start, and duration controls how long each transition takes.",
    },
  ],
};
